import type { FeatureFlag } from '@pflegenavi/shared/api';

class UserProfileUserDto {
  id!: string;
  firstName!: string;
  lastName!: string;
  eMail!: string;
  locale?: string;
  createdAt?: Date;
}
export class UserProfileDto {
  user!: UserProfileUserDto;
  featureFlags!: FeatureFlag[];
}

export const UserProfileControllerDefinition = {
  controller: 'userProfile',
  endpoints: {
    getUserProfile: {
      method: 'GET',
      url: '',
      response: UserProfileDto.prototype,
    },
  },
} as const;

export type UserProfileControllerResultTypes = {
  [key in keyof (typeof UserProfileControllerDefinition)['endpoints']]: (typeof UserProfileControllerDefinition)['endpoints'][key]['response'];
};
